const SMALL_MOBILE_MAX_WIDTH = 320;
const MOBILE_MAX_WIDTH = 639;
const SMALL_TABLET_MAX_WIDTH = 767;
const TABLET_MAX_WIDTH = 1023;
const XXL_MAX_WIDTH = 1535;

export const MOBILE = MOBILE_MAX_WIDTH + 1;
export const TABLET = SMALL_TABLET_MAX_WIDTH + 1;
export const SMALL_DESKTOP = TABLET_MAX_WIDTH + 1;
export const XXL = XXL_MAX_WIDTH + 1;

export function isSmallMobileWidth(currentScreenWidth: number) {
	return currentScreenWidth <= SMALL_MOBILE_MAX_WIDTH;
}

export function isMobileWidth(currentScreenWidth: number) {
	return currentScreenWidth <= MOBILE_MAX_WIDTH;
}

export function isSmallTabletWidth(currentScreenWidth: number) {
	return currentScreenWidth <= SMALL_TABLET_MAX_WIDTH;
}

export function isTabletWidth(currentScreenWidth: number) {
	return currentScreenWidth <= TABLET_MAX_WIDTH;
}

export function isDesktopWidth(currentScreenWidth: number) {
	return currentScreenWidth <= XXL_MAX_WIDTH;
}

export function isXxlWidth(currentScreenWidth: number) {
	return currentScreenWidth > XXL_MAX_WIDTH;
}
